export enum ShowOnAvailabilitiesListEnum {
  DoNotShow = 'do-not-show',
  ShowRootOrFacility = 'show-root-or-facility',
  ShowPatient = 'show-patient',
}

export type TAppointmentBookedTimeZoneStorage = {
  setting: ShowOnAvailabilitiesListEnum;
  IANA: string;
  abbreviation: string;
};
